var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C12.7614 10 15 7.76142 15 5C15 2.23858 12.7614 0 10 0C7.23858 0 5 2.23858 5 5C5 7.76142 7.23858 10 10 10ZM13.3333 5C13.3333 6.84095 11.8409 8.33333 10 8.33333C8.15905 8.33333 6.66667 6.84095 6.66667 5C6.66667 3.15905 8.15905 1.66667 10 1.66667C11.8409 1.66667 13.3333 3.15905 13.3333 5Z",
    fill: "#0FCB02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.3333C20 20 18.3333 20 18.3333 20H1.66667C1.66667 20 0 20 0 18.3333C0 16.6667 1.66667 11.6667 10 11.6667C18.3333 11.6667 20 16.6667 20 18.3333ZM18.3333 18.3275C18.3309 17.9162 18.077 16.6841 16.9465 15.5535C15.8594 14.4664 13.8152 13.3333 9.99998 13.3333C6.1848 13.3333 4.14059 14.4664 3.05349 15.5535C1.92292 16.6841 1.66904 17.9162 1.66667 18.3275H18.3333Z",
    fill: "#0FCB02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenProfileIcon);
export default __webpack_public_path__ + "static/media/green-profile-icon.74624145100fb52b6a9bedcee2c32bca.svg";
export { ForwardRef as ReactComponent };